import { useEffect, useRef, useState } from "react";
import "./styles/custom-select.css";

type ICustomSelectProps = {
  options: { label: string; value: string }[];
  value: string | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const CustomSelect = ({
  options,
  value,
  onChange,
  placeholder,
}: ICustomSelectProps) => {
  const [open, setOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (val: string) => {
    onChange(val);
    setOpen(false);
  };

  const selectedLabel =
    options.find((opt: any) => opt.value === value)?.label || placeholder;

  return (
    <div className="custom-select-container" ref={selectRef}>
      <button
        className="custom-select-trigger"
        onClick={() => setOpen((prev) => !prev)}
      >
        {selectedLabel}
        <span className="arrow">▾</span>
      </button>
      {open && (
        <ul className="custom-select-options">
          {options.map((opt: any) => (
            <li
              key={opt.value}
              className="custom-select-option"
              onClick={() => handleSelect(opt.value)}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
export default CustomSelect;
